module.exports = __webpack_public_path__ + "media/images/lb/768-a80251e15145dd65a239d9c8b670d9cf.svg";